<template>
  <Modal title="Hmm..." @close="close">
    <template #body>
      <p>It looks like chat failed to initialize.</p>
      <p>
        Our chat service requires third-party cookies and browser session storage to be enabled in
        order for chat to operate. Please ensure your browser is allowing third-party storage for
        this session, and try again.
      </p>
      <p class="text-secondary text-center">Need help? Call us any time.</p>
      <div class="d-flex justify-content-center">
        <div @mouseover="callMouseOver" @mouseleave="callMouseLeave">
          <Btn
            @click="openSupportCall"
            :icon="{
              default: { icon: 'fa-regular fa-phone-volume' },
              hover: { icon: 'fa-solid fa-phone-volume' },
            }"
          />
        </div>
      </div>
    </template>
    <template #footer>
      <Btn variant="secondary" type="button" @click="close"> Close </Btn>
    </template>
  </Modal>
</template>

<script>
import Btn from "@/components/display/Btn";
import Modal from "@/components/display/Modal";
import { ref } from "vue";
import store from "@/store";
import SupportCallModal from "@/components/smart/modals/SupportCall";

export default {
  name: "ChatErrorModal",
  components: {
    Btn,
    Modal,
  },
  emits: ["close"],
  props: {},
  setup(props, { emit }) {
    const callIconColor = ref("gamma");

    const callMouseOver = () => (callIconColor.value = "default");
    const callMouseLeave = () => (callIconColor.value = "gamma");

    const close = () => emit("close");

    const openSupportCall = () => {
      close();
      store.dispatch("modals/open", {
        template: SupportCallModal,
        id: "support-call-modal",
      });
    };

    return {
      callIconColor,
      callMouseLeave,
      callMouseOver,
      close,
      openSupportCall,
    };
  },
};
</script>
